<script>import FooterAlternative2 from "./footer-alternative2.svelte";
import FooterDefault from "./footer-default.svelte";
import FooterSeo from "./footer-seo.svelte";
import { AppMode, appMode, stateUi } from "@infinitro/config";
import { isMobile } from "@infinitro/global";
$: useAlternative2 = $stateUi.footer?.footerStyle === "alternative2";
$: useEmbeddedShellDecor = $stateUi.footer?.useEmbeddedShellDecor ?? false;
</script>

{#if useAlternative2 && $isMobile}
	<div class="footer-container">
		<FooterAlternative2 />
	</div>
{:else if useEmbeddedShellDecor && appMode === AppMode.Public}
	<FooterSeo />
{:else}
	<FooterDefault />
{/if}

<style>
	.footer-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center
}
</style>
